
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signup-student",
      function () {
        return require("private-next-pages/signup-student.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/signup-student"])
      });
    }
  